import { useTranslation } from 'react-i18next'

import { ThankYouContainerProps as Props } from './types'
import { ThankYouForm, ThankYouForwardEvents } from './index'

import PoweredBy from 'common/components/poweredBy'
import { usePostLeadContext } from 'modules/lead/context'

import './thankYouContainer.scss'

const ThankYouContainer = ({ transmission }: Props) => {
  const { t } = useTranslation()

  const { response: { name } } = usePostLeadContext()

  return (
    <div className="thank-you-container" data-test="thank-you-container">
      <section className="header">
        <h2>{t('thank-form.title', { username: name })}</h2>
        <p>{t('thank-form.subtitle')}</p>
      </section>
      <ThankYouForm transmissionCode={transmission.code} />
      <ThankYouForwardEvents transmissionCode={transmission.code} />
      <section className="footer">
        <PoweredBy />
      </section>
    </div>
  )
}

export default ThankYouContainer
